interface QueueableTask<TData> {
    data: TData;
    type: string;
}

interface Queueable {
    addTask: <TData>(task: QueueableTask<TData>, subEntityType?: string, subEntityId?: number) => void;
}

declare const queueable: Queueable | undefined;

export const queueableApi = {
    addTask: <TData>(task: QueueableTask<TData>) => {
        if (typeof queueable === 'undefined') {
            return Promise.reject(new Error('Queueable is not initialized'));
        }

        queueable.addTask(task);

        return Promise.resolve();
    },
};
